import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyAjMOQ0tlVRbXwdVdhXrOU2OLEVPWafyQY",
  authDomain: "desperate-oasis.firebaseapp.com",
  projectId: "desperate-oasis",
  storageBucket: "desperate-oasis.firebasestorage.app",
  messagingSenderId: "229046745513",
  appId: "1:229046745513:web:32e7758b63403149fbecb8",
  measurementId: "G-EV3HXSZNRE"
};

const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);
